<template>
  <div>
    <el-dialog
      :title="$t('common.addAdsenseBatch')"
      :visible.sync="visible"
      :width="$i18n.locale == 'zh'? '600px': '700px'"
      :close-on-click-modal="false"
      :before-close="closeDialog">
      <el-form ref="form" :model="form" :rules="formRules" :label-width="$i18n.locale == 'zh'? '110px': '200px'" label-position="left">
        <el-form-item :label="$t('table.accessMode')">
          <el-radio-group v-model="form.docking_type">
            <el-radio  :label="1">SDK</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('table.appName')" prop="application_id">
          <el-select 
            v-model="form.application_id" 
            filterable
            multiple
            collapse-tags
            :placeholder="$t('common.selectApp')"
            style="width: 300px;"
          >
            <el-option
              v-for="(item,index) in appList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="GPID">
          <el-input v-model="form.gpid" style="width: 300px;" :placeholder="$t('common.enter') + 'GPID'"></el-input>
        </el-form-item>
        <el-form-item :label="$t('table.coMode')" prop="co_mode">
          <el-select 
            v-model="form.co_mode" 
            filterable 
            :placeholder="$t('common.selectMode')"
            style="width: 300px;"
            @change="comodeChange"
          >
              <el-option
              v-for="(item,index) in $com.abroadList.modeList"
              :key="item.id"
              :label="$i18n.locale == 'zh'?item.name : item.en_name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <div v-if="form.co_mode == 1">
          <el-form-item :label="$t('table.pdPrice')" prop="min_price">
            <div  style="display: flex;">
              <el-input v-model="form.min_price" style="width: 300px;" @blur="formatMinPrice">
              </el-input> 
              <span> {{form.co_mode == 1 && form.area == 2? $t('common.meiyuan'): $t('common.yuan')}}/cpm</span>
            </div>
          </el-form-item>
        </div>
        <!-- 广告类型 -->
        <el-form-item :label="$t('sdk.flowType')" prop="flow_type">
          <el-select 
            v-model="form.flow_type" 
            filterable
            :placeholder="$t('common.selectFlowType')"
            style="width: 300px;"
            @change="flowTypeChange"
          >
              <el-option
              v-for="(item,index) in $com.abroadList.flowTypeList"
              :key="item.id"
              :label="$i18n.locale == 'zh'?item.name : item.en_name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('sdk.createNum')" prop="batch_num">
          <el-input-number v-model="form.batch_num" :min="1" :max="10"></el-input-number>
        </el-form-item>
        <!-- 信息流渲染方式 -->
        <el-form-item :label="$t('common.informationMothod')">
          <el-radio-group v-model="form.rendering_type">
            <el-radio-button :label="1">{{$t('sdk.platformRender')}}</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">{{$t('cancel')}}</el-button>
        <el-button type="primary" @click="onSave" :disabled="isDisabled">{{$t('save')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        application_id: [], //应用id
        co_mode: 2, //合作模式
        gpid: "", //GPID
        docking_type: 1,
        min_price: null, //Flat-CPM
        flow_type: [], //流量类型
        rendering_type: 1, //渲染方式
        area: 2, // 合作地区（1国内 2海外）
        batch_num: 1, // 新增参数 添加广告位数量，范围 [1-10]
        template_id: [], //对应流量类型下的模版，默认都选
      },
      formRules: {
        application_id: [
          { required: true, message: this.$t('common.selectApp'), trigger: 'change' }
        ],
        co_mode: [
          { required: true, message: this.$t('common.selectMode'), trigger: 'change' }
        ],
        min_price: [
          { required: true, message: this.$t('required.pdPrice'), trigger: "blur"},
          { 
            validator: (rule, value, callback) => {
              const num = parseFloat(value);
              if (isNaN((num))) {
                callback(new Error(this.$t('required.pdPriceNumber')));
                return;
              }
              if (num <= 0 || num > 999.99) {
                callback(new Error(this.$t('required.pdPriceRange')));
                return;
              }
              const decimalPart = String(num).split('.')[1] || '';
              if (decimalPart.length > 2) {
                callback(new Error(this.$t('required.pdPriceFloat')));
                return;
              }
              callback();
            },
            trigger: ["change", "blur"]
          }
        ],
        flow_type: [
          { required: true, message:  this.$t('common.selectFlowType'), trigger: 'change' }
        ],
      },
      appList: [],
      isDisabled: false, // 防止重复点击
      timer: null
    }
  },
  watch: {
    'form.flow_type': {
      handler(newVal) {
        let item = this.$com.abroadList.flowTypeList.filter(flow => newVal == flow.id)
        this.form.template_id = [item[0].id]
      },
      immediate: true
    },
  },
  created() {
    this.getAPPList()
  },
  beforeDestroy() {
    if(this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
  },
  methods: {
    closeDialog() {
      this.$nextTick(() => {
        this.docking_type = 1
        this.$refs.form.resetFields()
      })
      this.$emit('updateVisible', false);
    },
    getAPPList() {
      let params = {
        page: 1,
        page_size: 1000,
      };
      this.__postData('sspAppList', params, (res) => {
        if(res.list){
          this.appList = res.list
        }
      })
    },
    comodeChange() {
      this.form.min_price = null
    },
    formatMinPrice() {
      const value = this.form.min_price
      if (value === '' || value === null) return
      
      const num = parseFloat(value)
      if (!isNaN(num)) {
        this.form.min_price = num.toFixed(2)
      }
    },
    onSave() {
      this.isDisabled = true
      this.timer = setTimeout(() => {
        this.isDisabled = false
        clearTimeout(this.timer)
      }, 1500);
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.__postData('adAddOrUpdateBatch', this.form, (res) => {
            console.log(res, "res")
            clearTimeout(this.timer)
            this.timer = null
            if(res.code == 1) {
              this.$message.error({
                message: res.msg,
                type: 'error'
              })
            } else {
              this.$message.success('广告位批量添加成功')
              this.closeDialog()
            }
            this.isDisabled = false
          })
        } else {
          this.isDisabled = false
          clearTimeout(this.timer);
          this.timer = null;
          return false;
        }
      })
    } 
  }
};
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}
.el-select {
  width: 100%;
}
</style>